import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { experiencesQueryPrefix } from '#providers/experiences/Experience.helpers.ts';

export const useResetExperiences = () => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    queryClient.resetQueries({ queryKey: experiencesQueryPrefix });
  }, [queryClient]);
};
